export enum MEETING_EVENTS {
  PENDING = "0",
  ACCEPT = "1",
  DECLINE = "2",
  RESCHEDULE = "3",
}

export enum MEETING_LIST_EVENT {
  PENDING = "0",
  COMPLETE = "1",
  RESCHEDULE = "2",
  CANCELED = "3",
}
